module.exports = __webpack_public_path__ + "why12.webp?c2d20ada69370140a17bf91fcb8aa9a1";